import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/container';
import { AppTask } from '@domain/tasks/models/Task';

export const useTasks = (unfinishedOnly = false) => {
  const queryClient = useQueryClient();
  const {
    data: tasks,
    isLoading,
    error,
  } = useQuery<AppTask[]>({
    queryKey: ['tasks', unfinishedOnly],
    queryFn: async () => {
      const result = await container.taskRepository.getTasks(unfinishedOnly);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
  });

  const { mutateAsync: acknowledgeTask, isPending: isAcknowledging } = useMutation({
    mutationFn: async (taskId: string) => {
      const result = await container.taskRepository.acknowledgeTask(taskId);
      if (result.status === 'error') throw new Error(result.error.message);
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
  });

  return {
    tasks: tasks ?? [],
    isLoading,
    error,
    acknowledgeTask,
    isAcknowledging,
  };
};
